import { createContext } from 'preact';

type AccessibleContextProps = {
  /**
   * The id of an external label element for some component.
   */
  UNSAFE_ariaLabelledBy?: string;
};

/**
 * Context used by the parent to pass accessibility related information.
 */
const AccessibleContext = createContext<AccessibleContextProps>({
  UNSAFE_ariaLabelledBy: undefined
});

export { AccessibleContext };
export type { AccessibleContextProps };
